import { Link } from 'react-router-dom';

export default function Enrolment() {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-[#F5F1E8]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-white rounded-2xl shadow-2xl p-12 text-center">
          <div className="w-20 h-20 flex items-center justify-center bg-[#FFE66D] rounded-full mx-auto mb-6">
            <i className="ri-calendar-check-line text-4xl text-[#153223]"></i>
          </div>
          
          <h2 className="font-['Yeseva_One',serif] text-4xl md:text-5xl text-[#153223] mb-6">
            Enrolment for January 2026
          </h2>
          
          <p className="text-xl text-gray-700 mb-4 leading-relaxed">
            Due to our small class sizes, seats are limited.
          </p>
          <p className="text-lg text-gray-600 mb-10 leading-relaxed">
            Parents are encouraged to register early to secure a place.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link 
              to="/level-test-registration"
              onClick={handleScrollToTop}
              className="whitespace-nowrap bg-[#153223] hover:bg-[#1f4433] text-white font-bold px-8 py-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer flex items-center gap-2"
            >
              <i className="ri-calendar-line text-xl"></i>
              Register for Jan 2026
            </Link>
            <a 
              href="https://wa.link/zxuf0o"
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap bg-[#FFE66D] hover:bg-[#FFD93D] text-[#153223] font-bold px-8 py-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer flex items-center gap-2"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Contact Us
            </a>
          </div>

          <div className="mt-10 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-600 italic">
              Limited spots available • Early registration recommended • Personalized class placement
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
